import { Instagram, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img src="/logo.png" alt="Purevia Güzellik Bursa" className="h-12 w-auto brightness-110" />
            </div>
            <p className="text-sm text-white/50 leading-relaxed max-w-xs">
              Bursa'nın premium güzellik ve bakım merkezi. Uzman kadromuzla güzelliğinize değer katıyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] gold-text-light mb-6">
              Hızlı Bağlantılar
            </h4>
            <div className="space-y-3">
              {[
                { label: "Hizmetler", href: "#hizmetler" },
                { label: "Hakkımızda", href: "#hakkimizda" },
                { label: "Yorumlar", href: "#yorumlar" },
                { label: "İletişim", href: "#iletisim" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm text-white/50 hover:text-white transition-colors duration-300"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] gold-text-light mb-6">
              İletişim
            </h4>
            <div className="space-y-3">
              <a
                href="tel:+905441199544"
                className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors duration-300"
              >
                <Phone size={14} />
                0544 119 95 44
              </a>
              <a
                href="https://instagram.com/pureviaguzellikbursa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors duration-300"
              >
                <Instagram size={14} />
                @pureviaguzellikbursa
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Purevia Güzellik Bursa. Tüm hakları saklıdır.
          </p>
          <p className="text-xs text-white/30">
            Project by{" "}
            <a
              href="https://banabimedia.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gold-text-light font-semibold hover:text-white transition-colors duration-300"
            >
              Bana Bi Media
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
